// extracted by mini-css-extract-plugin
export var active = "CookiesBanner-module--active--b61c1";
export var button = "CookiesBanner-module--button--e8dd1";
export var buttonsWrapper = "CookiesBanner-module--buttonsWrapper--e2813";
export var container = "CookiesBanner-module--container--5b02b";
export var content = "CookiesBanner-module--content--ac376";
export var decline = "CookiesBanner-module--decline--50a7e";
export var hidden = "CookiesBanner-module--hidden--9b3c1";
export var innerContainer = "CookiesBanner-module--innerContainer--735b0";
export var visuallyHidden = "CookiesBanner-module--visuallyHidden--41525";